import clientSlice from "./clientSlice";
import downloadReleveSlice from "./downloadReleveSlice";
import listClientSlice from "./listClientSlice";

export const clientReducers = {
  clientSlice,
  listClientSlice,
  downloadReleveSlice,
};
